export default __webpack_public_path__ + "static/media/linkedin.96dc9766.svg";